import { useState, useRef, useEffect
 } from "react";
import Toast from "../lib/toast";
import styles from '../assets/styles/home.module.css'
import { getFirebaseEvents } from "../lib/firebase";
import { initialPage } from "../configs/settings";
import { useAuth } from "../lib/firebase";

// fix this no more hardcoding read it from firebase

/**
 * A Event Input + Autocomplete component
 * @param {{setEventPath: Function, funnySounds: boolean,sfxEnabled:boolean,showModal:boolean,setShowModal:Function,eventPath:string}} props The component props.
 * @returns {JSX.Element} the component
 */
export default function EventAutocomplete({ setEventPath, funnySounds, sfxEnabled, showModal,setShowModal,eventPath, eventList, setEventList, settingsYear }) {
    const [filtered, setFiltered] = useState([]);
    const {authentication} = useAuth();
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [highlighted, setHighlighted] = useState(-1);
    const listRef = useRef(null);
    const touchStartY = useRef(0);
    const touchMoved = useRef(false);
    const eventRef = useRef(null);
    const [userInput, setUserInput] = useState("");
    const devmodePath = "1690devmode"

    function handleChange(e) {
        const val = e.target.value;
        setUserInput(val);
        if (val.length > 0 && eventList) {
            const search = val.toLowerCase();

            const results = Array.from(eventList.entries())
                .filter(([key, name]) =>
                    key.toLowerCase().includes(search) ||
                    name.toLowerCase().includes(search)
                )
                .map(([key, name]) => ({ key, name }));

            setFiltered(results);
            setShowSuggestions(true);
            setHighlighted(-1);
        } else {
            setShowSuggestions(false);
        }
    };

    /**
     * Checks the validity of the entered event path
     */
    function checkEventValidity(input = userInput){
        let curInput = input.toLowerCase().replace(/\s/g, "");
        if(isNaN(parseInt(curInput.substring(0,4))) || curInput.length < 5){
            Toast.error("Not a valid event path. (First 4 characters must be a year)",funnySounds,sfxEnabled);
            // alert("Not a valid event path. (First 4 characters must be a year)");
            return;
        }
        else if(parseInt(curInput.substring(0,4)) !== parseInt(settingsYear)){
            Toast.error("Inputed Event Year and Settings Year Do Not Match.",funnySounds,sfxEnabled);
        }
        if (eventList && eventList.size > 0) {
            if (!eventList.has(curInput) && !curInput.includes(devmodePath)) {
                Toast.error("Event Path Not Found in Database", funnySounds, sfxEnabled);
                return;
            }
        }
        setEventPath(curInput);
        setUserInput(curInput);
        setShowModal(false);
    }

    const scrollIntoView = (index) => {
        const list = listRef.current;
        if (list && list.children[index]) {
        list.children[index].scrollIntoView({ block: "nearest", behavior: "smooth" });
        }
    };

    /**
     * Does initial setup for when editing the event path when it pops up
     */
    useEffect(() => {
        if (!showModal || !eventRef.current) return;

        const input = eventRef.current;
        input.focus();
        input.select();
        setUserInput(eventPath);
        console.log(eventList)

        return () => {};
    }, [showModal]);

    useEffect(() => {
        if (!navigator.onLine || authentication === false) {
            setEventList(new Map());
            return;
        }
        
        (async () => {
            let theDat = await getFirebaseEvents(authentication)
            setEventList(theDat);
            if(!theDat || (theDat instanceof Map && theDat.size === 0)) console.log("event fetching FAILED");
        })();
        
    }, [authentication]);

    /**
     * Handles enter keypresses
     */
    useEffect(() => {
        if (!showModal || !eventRef.current) return;

        const input = eventRef.current;
        const handleEnter = (e) => {
            if (e.key === "Enter" && highlighted === -1) {
                checkEventValidity(e.target.value);
            }
        };

        input.addEventListener("keydown", handleEnter);
        return () => input.removeEventListener("keydown", handleEnter);
    }, [showModal, highlighted]);

    const handleKeyDown = (e) => {
        if (e.key === "Escape") {
            setShowModal(false);
            return;
        }

        if (!showSuggestions) return;
        
        if (e.key === "ArrowDown") {
            e.preventDefault();
            const next = Math.min(highlighted + 1, filtered.length - 1);
            setHighlighted(next);
            if (next >= 0) scrollIntoView(next);
        } 
        else if (e.key === "ArrowUp") {
            e.preventDefault();
            const prev = Math.max(highlighted - 1, -1);
            setHighlighted(prev);
            if (prev >= 0) scrollIntoView(prev);
            else eventRef.current.focus();
        } 
        else if (e.key === "Enter" && highlighted >= 0) {
            e.preventDefault();
            handleSelect(filtered[highlighted]);
        }
    };
    /**
     * For when the autocomp li's are clicked
     * @param {} val 
     */
    const handleSelect = (eventObj) => {
        setUserInput(eventObj.key);
        setShowSuggestions(false);
        eventRef.current.focus();
        setHighlighted(-1);
    };
    return (
        <>
        <div className={showModal ? "tint" : "invisible" }></div>
        <div className={showModal ? styles.popup : "invisible"}>
            <input 
                className="textInput"
                ref={eventRef}
                type="text"
                onKeyDown={handleKeyDown}
                value={userInput}
                onChange={(e) => handleChange(e)}
                autoComplete="off"
                placeholder="Enter path"
                maxLength={initialPage.event_path.maxLength}
                />
            <div className={styles.popupBtns}>
                <button onClick={() => checkEventValidity()} className={styles.editBtn }>Confirm</button>
                <button onClick={() => setShowModal(false)} className={styles.editBtn }>Cancel</button>
            </div>
            {showSuggestions && filtered.length > 0 && (
                <ul ref={listRef} className={styles.autocomplist}>
                {filtered.map((ev, i) => (
                    <li 
                        key={ev.key}
                        onClick={() => {handleSelect(ev)}}
                        onTouchStart={(e) => {
                            touchStartY.current = e.touches[0].clientY;
                            touchMoved.current = false;
                            setHighlighted(i)}
                        }
                        onTouchMove={(e) => {
                            const deltaY = Math.abs(e.touches[0].clientY - touchStartY.current);
                            if (deltaY > 10) {   
                                touchMoved.current = true;
                            }
                        }}

                        onTouchEnd={() => {
                            if (!touchMoved.current) {
                                handleSelect(ev);
                            }
                        }}

                        style={{
                            backgroundColor: i === highlighted ? "var(--accentColor)" : "",
                            color: i === highlighted ? "var(--mainColor)" : "",
                            transition: "background-color 0.2s",
                        }}
                    >
                        {ev.key} - ({ev.name})
                    </li>
                ))}
                </ul>
            )}
        </div>
        </>
    );
}